import './qualification.css'
import { useState } from 'react'

const Qualification = () => {
  const [toggleState, setToggleState] = useState(2)
  const toggleTab = (index) => {
    setToggleState(index)
  }

  return (
    <section className='qualification section' id='qualification'>
      <h2 className='section__title'>Qualification</h2>
      <span className='section__subtitle'>my personal journey</span>

      <div className='qualification__container container'>
        <div className='qualification__tabs'>
          <div
            className={
              toggleState === 1
                ? 'qualification__button qualification__active button--flex'
                : 'qualification__button button--flex'
            }
            onClick={() => toggleTab(1)}>
            <i className='uil uil-graduation-cap qualification__icon'></i>
            Education
          </div>
          <div
            className={
              toggleState === 2
                ? 'qualification__button qualification__active button--flex'
                : 'qualification__button button--flex'
            }
            onClick={() => toggleTab(2)}>
            <i className='uil uil-briefcase-alt qualification__icon'></i>
            Experience
          </div>
        </div>
        <div className='qualification__sections'>
          <div
            className={
              toggleState === 1
                ? 'qualification__content qualification__content-active'
                : 'qualification__content'
            }>
            <div className='qualification__data'>
              <div>
                <br />
                <div className='qualification__calender'>2019</div>
                <h3 className='qualification__title'>• React/Redux and more</h3>
                <h3 className='qualification__title'>• Modern React</h3>
                <h3 className='qualification__title'>• Advanced CSS</h3>
                <span className='qualification__subtitle'>Udemy</span>
              </div>
              <div>
                <span className='qualification__rounder'></span>
                <span className='qualification__line'></span>
              </div>
            </div>

            <div className='qualification__data'>
              <div></div>
              <div>
                <span className='qualification__rounder'></span>
                <span className='qualification__line'></span>
              </div>
              <div>
                <br />
                <div className='qualification__calender'>2018</div>
                <h3 className='qualification__title'>• JavaScript</h3>
                <h3 className='qualification__title'>
                  • Intermediate JavaScript
                </h3>
                <h3 className='qualification__title'>• React</h3>
                <h3 className='qualification__title'>• React testing</h3>
                <span className='qualification__subtitle'>Codecademy</span>
              </div>
            </div>

            <div className='qualification__data'>
              <div>
                <br />
                <div className='qualification__calender'>2011</div>
                <h3 className='qualification__title'>JavaScript course</h3>
                <span className='qualification__subtitle'>
                  Bauman Moscow State Technical University
                </span>
              </div>
              <div>
                <span className='qualification__rounder'></span>
                <span className='qualification__line'></span>
              </div>
            </div>

            <div className='qualification__data'>
              <div></div>
              <div>
                <span className='qualification__rounder'></span>
                <span className='qualification__line'></span>
              </div>
              <div>
                <br />
                <div className='qualification__calender'>2010</div>
                <h3 className='qualification__title'>HTML/CSS course</h3>
                <span className='qualification__subtitle'>
                  Bauman Moscow State Technical University
                </span>
              </div>
            </div>
            <div className='qualification__data'>
              <div>
                <br />
                <div className='qualification__calender'>2007 - 2012</div>
                <h3 className='qualification__title'>
                  Economics | Master's degree
                </h3>
                <span className='qualification__subtitle'>
                  Financial University, Moscow
                </span>
              </div>
              <div>
                <span className='qualification__rounder'></span>
                <span className='qualification__line'></span>
              </div>
            </div>
          </div>

          <div
            className={
              toggleState === 2
                ? 'qualification__content qualification__content-active'
                : 'qualification__content'
            }>
            <div className='qualification__data'>
              <div></div>

              <div>
                <span className='qualification__rounder'></span>
                <span className='qualification__line'></span>
              </div>

              <div>
                <br />
                <div className='qualification__calender'>2021 - current</div>
                <h3 className='qualification__title'>Frontend Developer</h3>
                <span className='qualification__subtitle'>VTB</span>
              </div>
            </div>

            <div className='qualification__data'>
              <div>
                <br />
                <div className='qualification__calender'>2019 - 2021</div>
                <h3 className='qualification__title'>Frontend Developer</h3>
                <span className='qualification__subtitle'>Locko-Bank</span>
              </div>
              <div>
                <span className='qualification__rounder'></span>
                <span className='qualification__line'></span>
              </div>
            </div>

            {/* <div className='qualification__data'>
              <div></div>
              <div>
                <span className='qualification__rounder'></span>
                <span className='qualification__line'></span>
              </div>
              <div>
                <div className='qualification__calender'>2012 - 2020</div>
                <h3 className='qualification__title'>Web developer</h3>
                <span className='qualification__subtitle'>NPO Dozor</span>
              </div>
            </div> */}

            {/* <div className='qualification__data'>
              <div>
                <div className='qualification__calender'>2010 - 2012</div>
                <h3 className='qualification__title'>Web Content Manager</h3>
                <span className='qualification__subtitle'>RPG Area</span>
              </div>
              <div>
                <span className='qualification__rounder'></span>
                <span className='qualification__line'></span>
              </div>
            </div> */}
            {/* 
            <div className='qualification__data'>
              <div></div>
              <div>
                <span className='qualification__rounder'></span>
                <span className='qualification__line'></span>
              </div>
              <div>
                <div className='qualification__calender'>2010</div>
                <h3 className='qualification__title'>Web developer</h3>
                <span className='qualification__subtitle'>Mir Kolgot</span>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  )
}
export default Qualification
